import { Component } from '@angular/core';
import { HelperService } from '../../_helpers/helper.service';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
preloader: boolean = false;

constructor(
  public helperService: HelperService
) {

}

}
